import { generateUrl } from '../../../Commons';

export const truncateLabel = (label: string, maxLength = 15) => {
  const ellipsis = '...';
  return label.length > maxLength ? label.slice(0, maxLength - ellipsis.length) + ellipsis : label;
};

export const getDesktopStyles = (
  navLink: any,
  builderConfig: any,
  navLinkStyles: any,
  localStyles: any,
  pageUrls: any
) => {
  const baseMatch = generateUrl(navLink, pageUrls) === builderConfig?.slug?.replace(/(^\/)|(\/$)/g, '');
  if (baseMatch && !navLink.sectionId) {
    return {
      ...(navLinkStyles as any),
      color: (localStyles.selectedNavLinkColor || localStyles.navbarLinkStyles.color) ?? '',
    };
  }
  return navLinkStyles;
};

export const getMobileStyles = (navLink: any, builderConfig: any, navLinkStyles_Mobile: any, localStyles: any) => {
  const baseMatch = navLink.link === builderConfig?.slug?.replace(/(^\/)|(\/$)/g, '');
  if (baseMatch && !navLink.sectionId) {
    return {
      ...navLinkStyles_Mobile,
      color: (localStyles?.selectedNavLinkColor || localStyles?.navbarLinkStyles?.color) ?? '',
    };
  }
  return navLinkStyles_Mobile;
};

export const getBuilderDesktopStyles = (navLink: any, builderConfig: any, navLinkStyles: any, localStyles: any) => {
  if (navLink.pageId === builderConfig?.activePage && !navLink.sectionId) {
    return {
      ...navLinkStyles,
      color: (localStyles?.selectedNavLinkColor || localStyles?.navbarLinkStyles?.color) ?? '',
    };
  }
  return navLinkStyles;
};

export const getBuilderMobileStyles = (
  navLink: any,
  builderConfig: any,
  navLinkStyles_Mobile: any,
  localStyles: any
) => {
  if (navLink.pageId === builderConfig?.activePage && !navLink.sectionId) {
    return {
      ...navLinkStyles_Mobile,
      color: (localStyles.selectedNavLinkColor || localStyles.navbarLinkStyles.color) ?? '',
    };
  }
  return navLinkStyles_Mobile;
};
